import { AnyProductType, ProductBundleType } from "types";

import { Link } from "react-router-dom";
import ProductItemBase from "components/ProductItemBase";
import { routes } from "config";

const ProductItem = (props: {
  product: AnyProductType;
  wide?: boolean;
  thin?: boolean;
  hideInfo?: boolean;
}) => {
  let product = props.product as AnyProductType;
  const isBundle = product.isBundle;
  const isAAEHUDFactory = product.isAAEHUDFactory;
  // const isRegularProduct = !isBundle && !isAAEHUDFactory;

  let previousPrice = props.product.previousPrice;
  let is3DPrintable = props.product.is3DPrintable;

  if (isBundle) {
    const bundle = props.product as ProductBundleType;

    const productPricesSum = bundle.products
      ?.map((p) => p.price)
      .reduce((a, b) => a + b, 0);
    previousPrice = productPricesSum;

    if (!is3DPrintable) {
      is3DPrintable = !!bundle.products?.find((p) => p.is3DPrintable);
    }
  }

  return (
    <Link
      to={`/${
        isAAEHUDFactory ? routes.aaeHudFactory.slug : routes.eshop.slug
      }/${props.product.id}`}
    >
      <ProductItemBase
        product={props.product}
        price={
          !props.hideInfo
            ? {
                current: props.product.price,
                previous: previousPrice,
              }
            : undefined
        }
        wide={props.wide}
        thin={props.thin}
        subtitle={
          isBundle
            ? "Product Bundle"
            : isAAEHUDFactory
            ? "AAE HUD Factory v2"
            : ""
        }
        is3DPrintable={is3DPrintable}
      />
    </Link>
  );
};

export default ProductItem;
